// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

type TraceRecord = {
  timestamp: number
  lat: number
  lon: number
}
type GroupOptions = {
  maxInterval: number
  maxDistance: number
}
type TraceRecords = TraceRecord[]
const defaultOptions: GroupOptions = {
  maxInterval: 60,
  maxDistance: 100
}
export function groupTracks (tracks: TraceRecords, options?: TraceRecord): TraceRecords[] {
  const grouped = []
  let group = []
  let lastTrack = null
  const { maxInterval, maxDistance } = { ...options, ...defaultOptions }
  tracks.forEach(track => {
    if (!lastTrack) {
      lastTrack = track
    }
    let shouldSplit = track.timestamp - lastTrack.timestamp >= maxInterval
    if (shouldSplit || getGreatCircleDistance([lastTrack.lat, lastTrack.lon], [track.lat, track.lon]) >= maxDistance) {
      grouped.push(group)
      group = []
    }
    group.push(track)
    lastTrack = track
  })

  // Only when we split we push the group so we need to add that last one
  // that we are in the middle of creating
  if (group.length > 0) {
    grouped.push(group)
  }

  if (!grouped.length) {
    return [group]
  }

  return grouped
}

const EARTH_RADIUS = 6378137.0

const PI = Math.PI
function getRad (d) {
  return (d * PI) / 180.0
}

function getGreatCircleDistance ([lat1, lng1], [lat2, lng2]) {
  var radLat1 = getRad(lat1)
  var radLat2 = getRad(lat2)
  var a = radLat1 - radLat2
  var b = getRad(lng1) - getRad(lng2)
  var s =
    2 *
    Math.asin(
      Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2))
    )
  s = s * EARTH_RADIUS
  s = Math.round(s * 10000) / 10000.0
  return s
}
